import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './detail.css';
import Sidebar from '../../components/SideBar/Sidebar.js';
import { hideLoading, showLoading } from '../../store/loading-reducer';
import PropTypes from 'prop-types';
import { shopMonitorSliderTime } from '../../helpers/enums'; 
//import { formatDate } from '../../helpers/formatterHelper' 
import { getJobPostingsByFilter } from '../../store/hrbenefits/actions';
export default function ShopJobPostings({ handleloadinTiming }) {
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.loading);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [filter, setFilter] = useState({ companyId: 0, userId: 0, sort: 6, shopMonitor: true });
    const jobPostingWrapRef = useRef(null); 
    const { jobPostingsListByfilter } = useSelector(state => state.hrBenefits); 


    useEffect(() => {
        document.title = 'Job - Postings | CWP Team Connect';
        dispatch(showLoading());
        handleloadinTiming(shopMonitorSliderTime.LeadingTime);
        let sharpCompanyId = localStorage.getItem('monitor_mode_company');
        if (sharpCompanyId !== undefined && sharpCompanyId !== null) {
            setFilter({ ...filter, companyId: parseInt(sharpCompanyId) });
        }
    }, []);

    

    useEffect(() => { 
        dispatch(getJobPostingsByFilter(filter)).unwrap().then(() => {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
            setIsDataLoaded(true);
        });
    }, [dispatch]);

    useEffect(() => {
        if (isLoading && isDataLoaded) {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
        }
    }, [isLoading, isDataLoaded]);

    useEffect(() => {
        if (jobPostingWrapRef.current) {
            const items = jobPostingWrapRef.current.querySelectorAll('.contest-listing-item');
            if (items.length > 3) {
                jobPostingWrapRef.current.classList.add('many-contests');
            } else {
                jobPostingWrapRef.current.classList.remove('many-contests');
            }
        }
    }, []);
    console.log("jobPostingsListByfilterjobPostingsListByfilterjobPostingsListByfilter", jobPostingsListByfilter);
    return (
        <div className="monitors-inner">
            <div className="monitors-item contest-info-item">
                <div className="monitors-header-wrap">
                    <p className="monitors-header-title">Job Postings</p>
                    <span className="monitors-header-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
                            <path d="M2.38469 22.625C1.75323 22.625 1.21875 22.4062 0.78125 21.9688C0.34375 21.5312 0.125 20.9968 0.125 20.3653V7.38469C0.125 6.75323 0.34375 6.21875 0.78125 5.78125C1.21875 5.34375 1.75323 5.125 2.38469 5.125H7.625V3.00969C7.625 2.37823 7.84375 1.84375 8.28125 1.40625C8.71875 0.96875 9.25323 0.75 9.88469 0.75H14.1153C14.7468 0.75 15.2813 0.96875 15.7188 1.40625C16.1562 1.84375 16.375 2.37823 16.375 3.00969V5.125H21.6153C22.2468 5.125 22.7812 5.34375 23.2188 5.78125C23.6562 6.21875 23.875 6.75323 23.875 7.38469V20.3653C23.875 20.9968 23.6562 21.5312 23.2188 21.9688C22.7812 22.4062 22.2468 22.625 21.6153 22.625H2.38469ZM9.5 5.125H14.5V3.00969C14.5 2.91344 14.4599 2.82531 14.3797 2.74531C14.2997 2.6651 14.2116 2.625 14.1153 2.625H9.88469C9.78844 2.625 9.70031 2.6651 9.62031 2.74531C9.5401 2.82531 9.5 2.91344 9.5 3.00969V5.125ZM22 15.4375H15.125V16.495C15.125 16.8173 15.0172 17.0861 14.8016 17.3016C14.5861 17.5172 14.3173 17.625 13.995 17.625H10.005C9.68271 17.625 9.41385 17.5172 9.19844 17.3016C8.98281 17.0861 8.875 16.8173 8.875 16.495V15.4375H2V20.3653C2 20.4616 2.0401 20.5497 2.12031 20.6297C2.20031 20.7099 2.28844 20.75 2.38469 20.75H21.6153C21.7116 20.75 21.7997 20.7099 21.8797 20.6297C21.9599 20.5497 22 20.4616 22 20.3653V15.4375ZM10.75 15.75H13.25V13.25H10.75V15.75ZM2 13.5625H8.875V12.505C8.875 12.1827 8.98281 11.9139 9.19844 11.6984C9.41385 11.4828 9.68271 11.375 10.005 11.375H13.995C14.3173 11.375 14.5861 11.4828 14.8016 11.6984C15.0172 11.9139 15.125 12.1827 15.125 12.505V13.5625H22V7.38469C22 7.28844 21.9599 7.20031 21.8797 7.12031C21.7997 7.0401 21.7116 7 21.6153 7H2.38469C2.28844 7 2.20031 7.0401 2.12031 7.12031C2.0401 7.20031 2 7.28844 2 7.38469V13.5625Z" fill="#F96C6C" />
                        </svg>
                    </span>
                </div>
                <div className="monitors-item-event-wrap contest-item-column-wrap jobPosting-item-column-wrap">
                    <div className="contest-listing-wrap" ref={jobPostingWrapRef}>
                        {jobPostingsListByfilter?.length > 0 &&
                            jobPostingsListByfilter.slice(0, 8).map((item, index) => {
                                return (
                                    <a className="contest-listing-item jobPosting-listing-item" key={item?.id || index} >
                                        <span className="contest-top-info-wrap">
                                            <span className="contest-title">{item?.title}</span>
                                        </span>
                                        <span className="contest-information-wrap">
                                            <span className="contest-info-wrap">
                                                {/*<span className="contest-date"> Enter by {item?.createdDate && formatDate(item.createdDate, "MMM dd")} </span>*/}
                                            </span>
                                        </span>
                                    </a>
                                ); 
                            })
                        }
                    </div>
                </div>
            </div>
            <Sidebar pageType={"jobpostings"} />
        </div>
    );
}

ShopJobPostings.propTypes = {
    handleloadinTiming: PropTypes.func
};   